import React from 'react';

const WINE_PREFERENCE_OPTIONS = [
    { label: "Red", description: "Red Wines" },
    { label: "White", description: "White Wines" },
    { label: "Rosé", description: "Rosé Wines" },
    { label: "Sparkling", description: "Sparkling Wines" },
    { label: "Fortified", description: "Fortified Wines" },
    { label: "Orange", description: "Orange Wines" },
    { label: "Natural", description: "Natural Wines" },
    { label: "Light", description: "Light-bodied wines" },
    { label: "Medium", description: "Medium-bodied wines" },
    { label: "Full", description: "Full-bodied wines" },
    { label: "Dry", description: "Not sweet" },
    { label: "Off-Dry", description: "Slight sweetness" },
    { label: "Medium-Sweet", description: "Moderate sweetness" },
    { label: "Sweet", description: "Noticeable sweetness" },
    { label: "Fruity", description: "Fruit-forward flavors" },
    { label: "Fresh", description: "Fresh and vibrant flavors" },
    { label: "Floral", description: "Floral aromas" },
    { label: "Earthy", description: "Earth and mineral notes" },
    { label: "Oaky", description: "Oak influence" },
    { label: "Complex", description: "Complex flavor profile" },
];

const WinePreferencesStep = ({ 
    selectedWinePreferences,
    winePreferences,
    setWinePreferences,
    toggleWinePreference,
    handleWinePreferenceButtonClick,
    handleWinePreferenceChange,
    handleEnter,
    confirmationMessage,
    diningLocation,
    onNext,
    onBack
}) => {
    const winePreferencesQuestion = "What type of wine are you interested in?";

    return (
        <div className="step-container">
            {confirmationMessage && <h2>{confirmationMessage}</h2>}
            <h2>{winePreferencesQuestion}</h2>
            
            {/* Wine Preference Buttons */}
            <div className="preference-buttons">
                {WINE_PREFERENCE_OPTIONS.map((option) => (
                    <button
                        key={option.label}
                        type="button"
                        className={`pref-button ${(selectedWinePreferences || []).includes(option.label) ? 'selected' : ''}`}
                        onClick={() => diningLocation === 'eating_in' ? toggleWinePreference(option.label) : handleWinePreferenceButtonClick(option.label)}
                        title={option.description}
                    >
                        {option.label}
                    </button>
                ))}
            </div>

            <p className="message-text">
                Or type your wine preferences below:
            </p>

            {diningLocation === 'eating_in' ? (
                <>
                    {/* Free-form text input for wine preferences */}
                    <textarea
                        className="full-width-textarea"
                        placeholder="e.g., I'm looking for an organic, biodynamic wine."
                        value={winePreferences}
                        onChange={(e) => setWinePreferences(e.target.value)}
                        rows="3"
                    />
                </>
            ) : (
                <>
                    <textarea
                        placeholder="e.g., I'm looking for an organic, biodynamic wine."
                        value={winePreferences}
                        onChange={handleWinePreferenceChange}
                        onKeyDown={handleEnter}
                        rows="4"
                    />
                </>
            )}
            
            <div className="navigation-buttons">
                <button onClick={onBack}>Back</button>
                <button onClick={onNext}>Next</button>
            </div>
        </div>
    );
};

export default WinePreferencesStep;
